"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.perpPlugin = void 0;
const perp_module_1 = require("./perp.module");
const perpPlugin = (option) => {
    return {
        install(context) {
            const perp = new perp_module_1.PerpModule(context, option);
            context.addInitHook(async () => {
                await perp.configuration.update();
            });
            context.perp = perp;
        },
    };
};
exports.perpPlugin = perpPlugin;
